import SettingRoutes from "./SettingRoutes";
import SettingStore from "./SettingStore";
import SettingLinks from "./SettingLinks";

export default {
  install(Vue, options) {
    if (options.router) {
      options.router.addRoute(...SettingRoutes);
    }
    if (options.store) {
      options.store.registerModule("Setting", SettingStore);
      options.store.commit("Dashboard/SET_LINKS", SettingLinks);
    }
  },
};
